export const ALTERAR_DETALHAMENTO_CENTRO_CUSTO = 'ALTERAR_DETALHAMENTO_CENTRO_CUSTO'

export default function alterarExibicaoDetalhamentoCentroCusto (centroCusto) {
    return {
      type: ALTERAR_DETALHAMENTO_CENTRO_CUSTO,
      payload: centroCusto
    }
  }
